"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _CustomizedItem = _interopRequireDefault(require("../components/CustomizedItem"));
var AvatarCustomized = function AvatarCustomized(_ref) {
  var items = _ref.items;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "list--items avatar-customized d8-u-overflow-auto"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "grid__wrapper"
  }, items.map(function (item, i) {
    return /*#__PURE__*/_react["default"].createElement(_CustomizedItem["default"], {
      key: item.link,
      item: item,
      index: i,
      isLast: i + 1 === items.length
    });
  })));
};
AvatarCustomized.propTypes = {
  items: _propTypes["default"].array.isRequired
};
var _default = exports["default"] = AvatarCustomized;